export const trackInitiateCheckout = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout', {
      value: 6.39,
      currency: 'USD',
      content_name: 'CERO ATRASOS Plan 21 Dias',
      content_type: 'product',
    })
  }
}
